import React from 'react';
import { Handle, Position } from '@xyflow/react';

function ResourceGroupNode({ data, selected }) {
  return (
    <div
      className={`relative rounded-lg border-2 border-dashed p-3 transition-colors ${
        selected
          ? 'border-teal-500 bg-teal-50/60 dark:bg-teal-900/30'
          : 'border-teal-300 bg-teal-50/30 dark:bg-teal-900/20'
      }`}
      style={{ width: 220, height: 120 }}
    >
      <Handle type="target" position={Position.Top} className="!bg-teal-500" />
      <div className="mb-2 flex items-center gap-2">
        <svg
          className="h-4 w-4 text-teal-600 dark:text-teal-400"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M3 9h18" />
        </svg>
        <span className="text-sm font-semibold text-teal-800 dark:text-teal-200">{data.name}</span>
        {data.region && (
          <span className="ml-auto text-xs bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 px-2 py-0.5 rounded">
            {data.region}
          </span>
        )}
      </div>
      <div className="text-xs text-gray-500 dark:text-gray-400">Resource Group</div>
      <Handle type="source" position={Position.Bottom} className="!bg-teal-500" />
    </div>
  );
}

export default ResourceGroupNode;
